var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"directory-list"},[_c('directory-tree',{attrs:{"edit":_vm.edit,"drag-over-id":_vm.dragOverId,"statistic":_vm.statistic,"active-dir-id":_vm.activeDirId,"data":_vm.dirData},on:{"on-edit":_vm.onEdit,"on-drop":_vm.onDrop,"on-delete":_vm.onDelete,"on-click":_vm.onClick,"on-collapse":_vm.onCollapse,"on-change":_vm.onChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54d62ddc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/directory-list/index.vue
// module id = xgLM
// module chunks = 23